import { transport } from 'config/transport';

export function callApiGetDangKiMonHocInfo(congDoanId, classId) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${classId}/dangky`);
}
